import { render, staticRenderFns } from "./StartTourButton.vue?vue&type=template&id=761976cc"
import script from "./StartTourButton.vue?vue&type=script&lang=js"
export * from "./StartTourButton.vue?vue&type=script&lang=js"
import style0 from "./StartTourButton.vue?vue&type=style&index=0&id=761976cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports